
import { createDeckWidgetQueue } from './script_request_queue';

var deckWidgetQueue = createDeckWidgetQueue();

function fetchScript(url, params, options) {
  if (options) {
    deckWidgetQueue.enqueue(url, params, options);
  } else {
    deckWidgetQueue.enqueue(url, params);
  }
}

function initializeTypePreference() {
  var preference = getCurrentTypePreference()
  showDeckContainerTab(preference);
}

var showDeckContainerTab = function(preference) {
  document.querySelectorAll('.type-switcher-tabs, .deck-action-menu, .deck-price-menu').forEach(function(container) {
    var selected = findPreferredTabTrigger(container, preference);
    if (selected) {
      bootstrap.Tab.getOrCreateInstance(selected).show();
    }
  });
}

function findPreferredTabTrigger(container, preference) {
  if (!container || !preference) return null;
  // Use indexOf rather than .match() — .match() compiles `preference` as a
  // regex, and the URL fragment can contain regex metacharacters (e.g. a
  // trailing backslash from a Facebook fbclid like #paper\) that would crash
  // here with "Invalid regular expression: /tab-paper\/".
  var needle = "tab-" + preference;
  var matches = Array.from(container.querySelectorAll('a[data-bs-toggle="tab"]')).filter(function(el) {
    var href = el.getAttribute("href");
    return href && href.indexOf(needle) !== -1;
  });
  return matches.find(function(el) { return !el.classList.contains('dropdown-item'); }) || matches[0] || null;
}

function deckDisplayParams(container) {
  if (!container) return {};
  return {
    deck_group: container.dataset.deckGroup || 'type',
    deck_sort: container.dataset.deckSort || 'mana_value',
    deck_sort_direction: container.dataset.deckSortDirection || 'auto',
    deck_view: container.dataset.deckView || 'text',
  };
}

function deckStatsDisplayParams(container) {
  var params = deckDisplayParams(container);
  delete params.deck_view;
  return params;
}

function initializeDeckComponents(tabId, deckId, deckString, viewModeOverride, allowEmptyDeck, deckFormat, companion, commander, commanderAlt, showDeckWarnings, editablePreview, editablePreviewToken) {
  if (typeof commander === 'boolean' && commanderAlt === undefined && showDeckWarnings === undefined) {
    showDeckWarnings = commander;
    commander = undefined;
    commanderAlt = undefined;
  }
  var deckStringIfNoDeckId = (deckId == null || deckId =="") ? deckString : "";
  var useUnsavedDeckPost = (deckId == null || deckId === "") && deckStringIfNoDeckId != null && deckStringIfNoDeckId !== "";
  var hasDeckSource = (deckId != null && deckId !== "") || (deckStringIfNoDeckId != null && deckStringIfNoDeckId !== "") || allowEmptyDeck === true;
  var container = document.getElementById(tabId);
  var showDeckWarningsParam = showDeckWarnings === true;
  var lazyPaneRequestOptions = useUnsavedDeckPost ? { method: 'POST' } : undefined;

  function requestBaseParams(tab, hash) {
    var params = Object.assign({
      type: tab.dataset.type,
      id: deckId,
      deck: deckStringIfNoDeckId,
      deck_format: deckFormat,
      companion: companion,
      commander: commander,
      commander_alt: commanderAlt,
      selector: hash,
      view_mode_override: viewModeOverride,
      show_deck_warnings: showDeckWarningsParam,
    }, deckDisplayParams(container));
    if (editablePreview === true && editablePreviewToken) {
      params.editable_preview = true;
      params.editable_preview_token = editablePreviewToken;
    }
    return params;
  }

  function loadPane(tab, hash) {
    if (!hasDeckSource) return;
    if (!tab) return;
    if (tab.dataset.myPrice && !tab.dataset.loaded) {
      fetchScript('/deck/my_price_js', requestBaseParams(tab, hash), lazyPaneRequestOptions);
    } else if (tab.dataset.deckComponent && !tab.dataset.loaded) {
      fetchScript('/deck/component', requestBaseParams(tab, hash), lazyPaneRequestOptions);
    } else if (tab.dataset.deckStats && !tab.dataset.loaded) {
      fetchScript('/deck/stats', Object.assign({
        id: deckId,
        type: tab.dataset.type,
        deck: deckStringIfNoDeckId,
        deck_format: deckFormat,
        companion: companion,
        commander: commander,
        commander_alt: commanderAlt,
        selector: hash,
        view_mode_override: viewModeOverride,
      }, deckStatsDisplayParams(container)), lazyPaneRequestOptions);
    }
  }

  function loadTab(tabEl) {
    if (!container || !container.contains(tabEl)) return;
    if (!tabEl.matches('[data-bs-toggle="tab"]')) return;
    var hash = tabEl.getAttribute('href') || tabEl.dataset.bsTarget;
    // Use getElementById so numeric IDs (e.g. "413-tab-paper") work — those
    // start with a digit and are invalid as CSS selectors for querySelector.
    var tabId2 = hash && hash.charAt(0) === '#' ? hash.slice(1) : hash;
    var tab = tabId2 ? document.getElementById(tabId2) : null;
    loadPane(tab, hash);
  }

  function activeDeckPane() {
    if (!container) return null;
    return container.querySelector('.tab-pane.active[data-deck-component="true"], .tab-pane.active[data-my-price="true"]');
  }

  function reloadActiveDeckPane() {
    var tab = activeDeckPane();
    if (!tab) return;
    tab.innerHTML = "<p class='text-center text-muted'>Loading ...</p>";
    loadPane(tab, '#' + tab.id);
  }

  function resetDeckPanes() {
    if (!container) return;
    container.querySelectorAll('.tab-pane[data-deck-component="true"], .tab-pane[data-my-price="true"]').forEach(function(tab) {
      delete tab.dataset.loaded;
    });
  }

  document.addEventListener('shown.bs.tab', function(e) {
    loadTab(e.target);
  });

  var initialPreference = getCurrentTypePreference();
  var initialTab = findPreferredTabTrigger(container, initialPreference);
  if (!initialTab) {
    initialTab = document.querySelector('#' + CSS.escape(tabId) + ' a.nav-link.active[data-bs-toggle="tab"]');
  }
  if (initialTab) {
    loadTab(initialTab);
  } else {
    var initialPane = activeDeckPane();
    if (initialPane) loadPane(initialPane, '#' + initialPane.id);
  }

  if (container) {
    container.addEventListener('change', function(e) {
      var control = e.target && e.target.closest('.deck-display-control-select');
      if (!control) return;

      var groupControl = container.querySelector('.deck-display-group');
      var sortControl = container.querySelector('.deck-display-sort');
      var directionControl = container.querySelector('.deck-display-direction');
      var viewControl = container.querySelector('.deck-display-view');
      if (groupControl) container.dataset.deckGroup = groupControl.value;
      if (sortControl) container.dataset.deckSort = sortControl.value;
      if (directionControl) container.dataset.deckSortDirection = directionControl.value;
      if (viewControl) container.dataset.deckView = viewControl.value;
      resetDeckPanes();
      reloadActiveDeckPane();
    });

    container.addEventListener('click', function(e) {
      var toggle = e.target && e.target.closest('.deck-view-options-toggle');
      if (!toggle) return;
      var shell = container.querySelector('.deck-display-controls-shell');
      if (!shell) return;
      var open = !shell.classList.contains('is-open');
      shell.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
}

var editablePreviewRequestSequence = 0;
var editablePreviewAbortController = null;
var editablePreviewQuantityTimers = new Map();
var editablePreviewPendingQuantities = new Map();
var editablePreviewPending = Promise.resolve(true);
var editablePreviewPendingCount = 0;
var editablePreviewPendingFailed = false;
var editablePreviewPendingFailedDelta = false;
var EDITABLE_PREVIEW_QUANTITY_DELAY = 150;

function deckPreviewInputSnapshot() {
  return [
    document.getElementById('deck_input_deck')?.value || '',
    document.getElementById('deck_input_sideboard')?.value || '',
    document.getElementById('deck_input_maybeboard')?.value || ''
  ].join("\u001f");
}

function editablePreviewRowKey(row) {
  if (!row) return null;
  return [
    row.dataset.editBoard || '',
    row.dataset.editCard || '',
    row.dataset.editCategory || ''
  ].join("\u001f");
}

function syncEditablePreviewQuantityDigits(element, value) {
  if (!element) return;
  element.style.setProperty('--deck-preview-quantity-digits', String(Math.max(String(value || '').length, 2)));
}

function clearEditablePreviewQuantityTimer(row, clearPendingQuantity) {
  if (row) {
    var rowKey = editablePreviewRowKey(row);
    if (!rowKey) return;
    var rowTimerEntry = editablePreviewQuantityTimers.get(rowKey);
    if (rowTimerEntry) {
      clearTimeout(rowTimerEntry.timer || rowTimerEntry);
      editablePreviewQuantityTimers.delete(rowKey);
    }
    if (clearPendingQuantity) {
      editablePreviewPendingQuantities.delete(rowKey);
      delete row.dataset.pendingDeckQuantity;
    }
    return;
  }
  editablePreviewQuantityTimers.forEach(function(timerEntry) {
    clearTimeout(timerEntry.timer || timerEntry);
  });
  editablePreviewQuantityTimers.clear();
  editablePreviewPendingQuantities.clear();
}

window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.clearEditablePreviewQuantityTimer = clearEditablePreviewQuantityTimer;

function deckPreviewRequestParams(delta) {
  var preview = document.getElementById('deck-preview');
  var params = new URLSearchParams({
    deck: document.getElementById('deck_input_deck').value,
    sideboard: document.getElementById('deck_input_sideboard')?.value || '',
    maybeboard: document.getElementById('deck_input_maybeboard')?.value || '',
    name: document.getElementById('deck_input_name').value,
    companion: document.getElementById('deck_input_companion').value,
    commander: document.getElementById('deck_input_commander').value,
    commander_alt: document.getElementById('deck_input_commander_alt').value,
    format: document.getElementById('deck_input_format').value,
    subformat: document.getElementById('deck_input_subformat').value,
    author: document.getElementById('deck_input_author')?.value || '',
    specific_cards: document.getElementById('deck_input_specific_cards')?.checked || false
  });
  if (preview && preview.dataset.editablePreview === 'true') {
    params.set('editable_preview', 'true');
  }
  var displayContainer = preview && preview.querySelector('.deck-table-buttons-container');
  Object.entries(deckDisplayParams(displayContainer)).forEach(function(entry) {
    params.set(entry[0], entry[1]);
  });
  if (delta) {
    Object.keys(delta).forEach(function(key) {
      params.set('delta[' + key + ']', delta[key] == null ? '' : delta[key]);
    });
  }
  return params;
}

function setDeckPreviewStatus(message, isError) {
  var status = document.getElementById('deck-preview-status');
  if (!status) return;
  status.textContent = message || '';
  status.classList.toggle('text-danger', !!isError);
  status.classList.toggle('sr-only', !isError);
}

function applyDeckPreviewScript(js) {
  var token = String(Date.now()) + '-' + Math.random();
  window.MTGGoldfish = window.MTGGoldfish || {};
  window.MTGGoldfish.editablePreviewApplyToken = null;
  new Function(js + "\n;window.MTGGoldfish.editablePreviewApplyToken = " + JSON.stringify(token) + ";")();
  return window.MTGGoldfish.editablePreviewApplyToken === token;
}

function requestDeckPreview(delta) {
  var sequence = ++editablePreviewRequestSequence;
  editablePreviewAbortController = typeof AbortController === 'undefined' ? null : new AbortController();
  var inputSnapshot = deckPreviewInputSnapshot();
  var requestParams = deckPreviewRequestParams(delta);
  setDeckPreviewStatus('Updating deck preview...', false);

  var csrfMeta = document.querySelector('meta[name="csrf-token"]');
  return fetch('/deck/preview_js', {
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrfMeta ? csrfMeta.getAttribute('content') : '',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'text/javascript'
    },
    body: requestParams.toString(),
    signal: editablePreviewAbortController ? editablePreviewAbortController.signal : undefined
  }).then(function(res) {
    return res.text().then(function(js) {
      var contentType = (res.headers.get('content-type') || '').toLowerCase();
      if (!res.ok || contentType.indexOf('javascript') === -1) {
        throw new Error('Unable to update deck preview');
      }
      if (sequence !== editablePreviewRequestSequence) return true;
      if (inputSnapshot !== deckPreviewInputSnapshot()) {
        setDeckPreviewStatus('Deck preview was not applied because the deck list changed during the update.', true);
        return false;
      }
      if (!applyDeckPreviewScript(js)) {
        throw new Error('Deck preview script did not complete');
      }
      setDeckPreviewStatus('Deck preview updated.', false);
      return true;
    });
  }).catch(function(error) {
    if (error && error.name === 'AbortError') return false;
    if (sequence !== editablePreviewRequestSequence) return false;
    setDeckPreviewStatus('Deck preview could not be updated. Your deck list was not changed.', true);
    if (window.Bugsnag) window.Bugsnag.notify(error);
    else console.error(error);
    return false;
  });
}

function enqueueDeckPreview(delta) {
  if (editablePreviewPendingCount === 0) {
    editablePreviewPending = Promise.resolve(true);
    editablePreviewPendingFailed = false;
    editablePreviewPendingFailedDelta = false;
  }
  editablePreviewPendingCount += 1;
  editablePreviewPending = editablePreviewPending.catch(function() { return false; }).then(function(previousResult) {
    return requestDeckPreview(delta).then(function(currentResult) {
      if (currentResult === false) {
        editablePreviewPendingFailed = true;
        if (delta) editablePreviewPendingFailedDelta = true;
      }
      return previousResult !== false && currentResult !== false && !editablePreviewPendingFailed;
    });
  }).finally(function() {
    editablePreviewPendingCount = Math.max(0, editablePreviewPendingCount - 1);
  });
  return editablePreviewPending;
}

function flushEditablePreviewQuantityTimers() {
  var timerEntries = Array.from(editablePreviewQuantityTimers.entries());
  timerEntries.forEach(function(entry) {
    var rowKey = entry[0];
    var timerEntry = entry[1];
    clearTimeout(timerEntry.timer || timerEntry);
    editablePreviewQuantityTimers.delete(rowKey);
    if (timerEntry.callback) timerEntry.callback();
  });
}

function editablePreviewHasSyncWork() {
  return editablePreviewQuantityTimers.size > 0 || editablePreviewPendingCount > 0 || editablePreviewPendingFailed;
}

function syncEditableDeckPreviewBeforeFormAction() {
  flushEditablePreviewQuantityTimers();
  return editablePreviewPending.catch(function() { return false; }).then(function(result) {
    return result !== false && !editablePreviewPendingFailed;
  });
}

function syncEditableDeckPreviewBeforePreviewRefresh() {
  flushEditablePreviewQuantityTimers();
  var hasActiveSyncWork = editablePreviewPendingCount > 0;
  if (!hasActiveSyncWork && editablePreviewPendingFailed && !editablePreviewPendingFailedDelta) return Promise.resolve(true);
  return editablePreviewPending.catch(function() { return false; }).then(function(result) {
    return result !== false && !editablePreviewPendingFailed;
  });
}

function deltaForEditablePreviewRow(row, operation, extra) {
  return Object.assign({
    operation: operation,
    source_board: row.dataset.editBoard,
    card: row.dataset.editCard,
    custom_category: row.dataset.editCategory || ''
  }, extra || {});
}

function editablePreviewQuantityValue(row) {
  var rowKey = editablePreviewRowKey(row);
  var pendingValue = rowKey ? editablePreviewPendingQuantities.get(rowKey) : null;
  if (pendingValue == null) pendingValue = row.dataset.pendingDeckQuantity;
  if (pendingValue != null && pendingValue !== '') {
    var pendingQuantity = parseInt(pendingValue, 10);
    return Number.isNaN(pendingQuantity) ? 1 : Math.max(0, pendingQuantity);
  }
  if (row.dataset.editQuantity != null && row.dataset.editQuantity !== '') {
    var editQuantity = parseInt(row.dataset.editQuantity, 10);
    if (!Number.isNaN(editQuantity)) return Math.max(0, editQuantity);
  }
  var quantityControl = row.querySelector('[data-deck-quantity]');
  if (!quantityControl) return 1;
  var rawValue = quantityControl.value;
  if (rawValue == null || rawValue === '') rawValue = quantityControl.dataset.deckQuantity;
  if (rawValue == null || rawValue === '') rawValue = quantityControl.textContent;
  var quantity = parseInt(rawValue, 10);
  return Number.isNaN(quantity) ? 1 : Math.max(0, quantity);
}

function renderedEditablePreviewQuantityValue(row) {
  if (row.dataset.editQuantity != null && row.dataset.editQuantity !== '') {
    var editQuantity = parseInt(row.dataset.editQuantity, 10);
    if (!Number.isNaN(editQuantity)) return Math.max(0, editQuantity);
  }
  var quantityControl = row.querySelector('[data-deck-quantity]');
  if (!quantityControl) return 1;
  var rawValue = quantityControl.value;
  if (rawValue == null || rawValue === '') rawValue = quantityControl.dataset.deckQuantity;
  if (rawValue == null || rawValue === '') rawValue = quantityControl.textContent;
  var quantity = parseInt(rawValue, 10);
  return Number.isNaN(quantity) ? 1 : Math.max(0, quantity);
}

function updateEditablePreviewQuantityDisplay(row, quantity) {
  var rowKey = editablePreviewRowKey(row);
  if (rowKey) editablePreviewPendingQuantities.set(rowKey, quantity);
  row.dataset.pendingDeckQuantity = String(quantity);
  row.dataset.editQuantity = String(quantity);
  var quantityControl = row.querySelector('[data-deck-quantity]');
  if (!quantityControl) return;
  quantityControl.dataset.deckQuantity = String(quantity);
  syncEditablePreviewQuantityDigits(quantityControl, quantity);
  if (quantityControl.matches('input, textarea, select')) quantityControl.value = String(quantity);
  else quantityControl.textContent = String(quantity);
}

function submitEditablePreviewQuantity(row, quantity) {
  if (Number.isNaN(quantity) || quantity < 0) {
    setDeckPreviewStatus('Quantity must be zero or greater.', true);
    return;
  }
  updateEditablePreviewQuantityDisplay(row, quantity);
  clearEditablePreviewQuantityTimer(row);
  var rowKey = editablePreviewRowKey(row);
  if (!rowKey) return;
  var callback = function() {
    editablePreviewQuantityTimers.delete(rowKey);
    enqueueDeckPreview(deltaForEditablePreviewRow(row, quantity === 0 ? 'delete' : 'quantity', { quantity: quantity }));
  };
  editablePreviewQuantityTimers.set(rowKey, {
    timer: setTimeout(callback, EDITABLE_PREVIEW_QUANTITY_DELAY),
    callback: callback
  });
}

function applyEditablePreviewPendingQuantities(preview) {
  if (!preview || editablePreviewPendingQuantities.size === 0) return;
  preview.querySelectorAll('[data-editable-deck-row="true"]').forEach(function(row) {
    var rowKey = editablePreviewRowKey(row);
    if (!rowKey || !editablePreviewPendingQuantities.has(rowKey)) return;
    var pendingQuantity = editablePreviewPendingQuantities.get(rowKey);
    if (renderedEditablePreviewQuantityValue(row) === pendingQuantity) {
      editablePreviewPendingQuantities.delete(rowKey);
      delete row.dataset.pendingDeckQuantity;
      return;
    }
    updateEditablePreviewQuantityDisplay(row, pendingQuantity);
  });
}

function beginEditablePreviewQuantityEdit(row) {
  var display = row.querySelector('.deck-preview-quantity-display[data-deck-quantity]');
  if (!display) return;
  var originalQuantity = editablePreviewQuantityValue(row);
  var input = document.createElement('input');
  input.type = 'number';
  input.min = '0';
  input.step = '1';
  input.value = originalQuantity;
  input.className = 'form-control form-control-sm deck-preview-quantity-input';
  input.dataset.deckQuantity = String(originalQuantity);
  input.setAttribute('aria-label', display.getAttribute('aria-label') || 'Quantity');
  syncEditablePreviewQuantityDigits(input, originalQuantity);
  display.replaceWith(input);
  input.focus();
  input.select();

  var committed = false;
  var restoreDisplay = function() {
    input.replaceWith(display);
    display.dataset.deckQuantity = String(originalQuantity);
    display.textContent = String(originalQuantity);
    syncEditablePreviewQuantityDigits(display, originalQuantity);
  };
  var commit = function() {
    if (committed) return;
    committed = true;
    var quantity = parseInt(input.value, 10);
    if (Number.isNaN(quantity) || quantity < 0) {
      restoreDisplay();
      setDeckPreviewStatus('Quantity must be zero or greater.', true);
      return;
    }
    submitEditablePreviewQuantity(row, quantity);
  };

  input.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      commit();
    } else if (event.key === 'Escape') {
      committed = true;
      restoreDisplay();
      display.focus();
    }
  });
  input.addEventListener('input', function() {
    syncEditablePreviewQuantityDigits(input, input.value);
  });
  input.addEventListener('blur', commit);
}

function initializeEditableDeckPreview() {
  var preview = document.getElementById('deck-preview');
  var updateButton = document.getElementById('preview');
  if (!preview || !updateButton) return;
  applyEditablePreviewPendingQuantities(preview);
  if (preview.dataset.editEventsBound === 'true') return;
  preview.dataset.editEventsBound = 'true';
  updateButton.addEventListener('click', function(event) {
    event.preventDefault();
    if (updateButton.dataset.editablePreviewSyncing === 'true') return;
    updateButton.dataset.editablePreviewSyncing = 'true';
    syncEditableDeckPreviewBeforePreviewRefresh().then(function(synchronized) {
      if (!synchronized) return false;
      return enqueueDeckPreview();
    }).then(function(result) {
      if (result === false) {
        setDeckPreviewStatus('Deck preview could not be synchronized. Please retry before updating the preview.', true);
      }
    }).finally(function() {
      delete updateButton.dataset.editablePreviewSyncing;
    });
  });

  var deckInput = document.getElementById('deck_input_deck');
  var form = deckInput && deckInput.closest('form');
  if (form && form.dataset.editablePreviewSubmitBound !== 'true') {
    form.dataset.editablePreviewSubmitBound = 'true';
    form.addEventListener('submit', function(event) {
      if (form.dataset.editablePreviewSubmitSynced === 'true') {
        delete form.dataset.editablePreviewSubmitSynced;
        return;
      }
      if (!editablePreviewHasSyncWork()) return;

      event.preventDefault();
      if (form.dataset.editablePreviewSubmitSyncing === 'true') return;
      form.dataset.editablePreviewSubmitSyncing = 'true';
      var submitter = event.submitter;
      if (submitter) submitter.setAttribute('aria-busy', 'true');
      syncEditableDeckPreviewBeforeFormAction().then(function(synchronized) {
        if (!synchronized) {
          setDeckPreviewStatus('Deck preview could not be synchronized. Please retry before submitting.', true);
          return;
        }
        form.dataset.editablePreviewSubmitSynced = 'true';
        if (form.requestSubmit) {
          form.requestSubmit(submitter || undefined);
        } else if (submitter && submitter.click) {
          submitter.click();
        } else {
          form.submit();
        }
      }).finally(function() {
        if (submitter) submitter.removeAttribute('aria-busy');
        delete form.dataset.editablePreviewSubmitSyncing;
      });
    });
  }

  preview.addEventListener('click', function(event) {
    var control = event.target.closest('[data-deck-edit-action]');
    if (!control) return;
    var row = control.closest('[data-editable-deck-row="true"]');
    if (!row) return;
    var action = control.dataset.deckEditAction;
    if (action === 'change_printing') {
      window.MTGGoldfish?.deckPrintingPicker?.openForPreviewRow(row);
    } else if (action === 'bulk_change_printing') {
      window.MTGGoldfish?.deckPrintingPicker?.open();
    } else if (action === 'edit_quantity') {
      updateEditablePreviewQuantityDisplay(row, editablePreviewQuantityValue(row));
      clearEditablePreviewQuantityTimer(row, true);
      beginEditablePreviewQuantityEdit(row);
    } else if (action === 'decrement' || action === 'increment') {
      var quantity = editablePreviewQuantityValue(row);
      quantity += action === 'increment' ? 1 : -1;
      quantity = Math.max(0, quantity);
      submitEditablePreviewQuantity(row, quantity);
    } else if (action === 'set_quantity') {
      var requestedQuantity = window.prompt('Set quantity', String(editablePreviewQuantityValue(row)));
      if (requestedQuantity == null) return;
      submitEditablePreviewQuantity(row, parseInt(requestedQuantity, 10));
    } else if (action === 'delete') {
      if (row.dataset.editCopyQuantity === '1') {
        submitEditablePreviewQuantity(row, Math.max(0, editablePreviewQuantityValue(row) - 1));
      } else {
        clearEditablePreviewQuantityTimer(row, true);
        enqueueDeckPreview(deltaForEditablePreviewRow(row, 'delete'));
      }
    } else if (action === 'move') {
      clearEditablePreviewQuantityTimer(row, true);
      enqueueDeckPreview(deltaForEditablePreviewRow(row, 'move', { destination_board: control.dataset.destinationBoard }));
    }
  });
}


var getCurrentTypePreference = function() {
  var url = document.location.toString();
  if (url.match('#')) {
    return url.split('#')[1];
  } else {
    var preference = Cookies.get('type-preference');
    if (preference == "online") {
    } else if (preference == "arena") {
    } else {
      preference = "paper";
    }
    return preference;
  }
}
window.getCurrentTypePreference = getCurrentTypePreference

function splitDecklistsIntoTwoColumns() {
  // only do for firefox and desktop
  if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 && window.matchMedia("screen and (min-width: 900px)").matches) {
    document.querySelectorAll(".deck-table-container").forEach(function(container) {
      if (!container.classList.contains("deck-table-container-text")) return;
      var tables = container.querySelectorAll(".deck-view-deck-table");
      if (tables.length !== 1) return;
      var table = tables[0];
      var secondTable = table.cloneNode(false);
      var rows = table.querySelectorAll("tr");
      var rowCount = Math.round(rows.length * 0.5);
      var tbody = document.createElement('tbody');
      secondTable.appendChild(tbody);
      Array.from(rows).slice(rowCount).forEach(function(row) {
        tbody.appendChild(row);
      });
      table.parentNode.appendChild(secondTable);
    });
  }
}

function canUseDeckVisualStackHover() {
  return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}

function deckVisualStackForTarget(target) {
  if (!target || !target.closest) return null;
  return target.closest('.deck-visual-container-stacks .deck-visual-category-stack, .deck-visual-container-copy_stacks .deck-visual-category-stack');
}

function resetDeckVisualStackHover(stack) {
  if (!stack) return;
  stack.style.removeProperty('--deck-visual-stack-hover-extra');
  stack.querySelectorAll('.deck-visual-card').forEach(function(card) {
    card.style.removeProperty('--deck-stack-hover-y');
    card.classList.remove('is-stack-hovered');
  });
}

function pointerRemainsInsideStack(stack, event) {
  if (!event || typeof document.elementFromPoint !== 'function') return false;
  var target = document.elementFromPoint(event.clientX, event.clientY);
  return !!(target && stack.contains(target));
}

function pointerWithinStackRect(stack, event) {
  if (!stack || !event) return false;
  var rect = stack.getBoundingClientRect();
  return event.clientX >= rect.left &&
    event.clientX <= rect.right &&
    event.clientY >= rect.top &&
    event.clientY <= rect.bottom;
}

var activeDeckVisualStack = null;

function deckVisualCardAtPoint(stack, event) {
  if (!stack || !event) return null;

  if (typeof document.elementFromPoint === 'function') {
    var target = document.elementFromPoint(event.clientX, event.clientY);
    var targetCard = target && target.closest && target.closest('.deck-visual-card');
    if (targetCard && stack.contains(targetCard)) return targetCard;
  }

  return Array.from(stack.querySelectorAll('.deck-visual-card')).find(function(card) {
    var rect = card.getBoundingClientRect();
    return event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
  }) || null;
}

function applyDeckVisualStackHover(card, stack) {
  if (!card || !stack || !canUseDeckVisualStackHover()) return;

  var cards = Array.from(stack.querySelectorAll('.deck-visual-card'));
  var hoverIndex = cards.indexOf(card);
  if (hoverIndex < 0) return;

  var stackStyle = window.getComputedStyle(stack);
  var offset = parseFloat(stackStyle.getPropertyValue('--deck-visual-stack-offset')) || 44;
  var cardStack = card.querySelector('.deck-visual-card-stack') || card;
  var cardHeight = Math.max(card.getBoundingClientRect().height, cardStack.getBoundingClientRect().height);
  var expansion = Math.max(cardHeight - offset, 0);
  var effectiveExpansion = hoverIndex === cards.length - 1 ? 0 : expansion;

  activeDeckVisualStack = stack;
  stack.style.setProperty('--deck-visual-stack-hover-extra', effectiveExpansion + 'px');
  cards.forEach(function(stackCard, index) {
    var baseY = index * offset;
    var y = baseY + (index > hoverIndex ? effectiveExpansion : 0);
    stackCard.style.setProperty('--deck-stack-hover-y', y + 'px');
    stackCard.classList.toggle('is-stack-hovered', index === hoverIndex);
  });
}

function initializeDeckVisualStackHover() {
  document.addEventListener('mouseover', function(e) {
    var stack = deckVisualStackForTarget(e.target);
    if (!stack) return;
    var card = deckVisualCardAtPoint(stack, e) || (e.target.closest && e.target.closest('.deck-visual-card'));
    if (!card || !stack.contains(card)) return;
    applyDeckVisualStackHover(card, stack);
  });

  document.addEventListener('mousemove', function(e) {
    if (activeDeckVisualStack && !pointerWithinStackRect(activeDeckVisualStack, e)) {
      resetDeckVisualStackHover(activeDeckVisualStack);
      activeDeckVisualStack = null;
      return;
    }

    var stack = deckVisualStackForTarget(e.target) || (activeDeckVisualStack && pointerWithinStackRect(activeDeckVisualStack, e) ? activeDeckVisualStack : null);
    if (!stack) return;
    var card = deckVisualCardAtPoint(stack, e) || (e.target.closest && e.target.closest('.deck-visual-card'));
    if (!card || !stack.contains(card)) return;
    applyDeckVisualStackHover(card, stack);
  });

  document.addEventListener('mouseout', function(e) {
    var stack = activeDeckVisualStack || deckVisualStackForTarget(e.target);
    if (!stack || pointerWithinStackRect(stack, e)) return;
    if (e.relatedTarget && stack.contains(e.relatedTarget)) return;
    window.setTimeout(function() {
      if (pointerRemainsInsideStack(stack, e) || pointerWithinStackRect(stack, e)) return;
      resetDeckVisualStackHover(stack);
      if (activeDeckVisualStack === stack) activeDeckVisualStack = null;
    }, 0);
  });

  document.addEventListener('focusin', function(e) {
    var stack = deckVisualStackForTarget(e.target);
    if (!stack) return;
    var card = e.target.closest && e.target.closest('.deck-visual-card');
    if (!card || !stack.contains(card)) return;
    applyDeckVisualStackHover(card, stack);
  });

  document.addEventListener('focusout', function(e) {
    var stack = deckVisualStackForTarget(e.target);
    if (!stack) return;
    if (e.relatedTarget && stack.contains(e.relatedTarget)) return;
    resetDeckVisualStackHover(stack);
    if (activeDeckVisualStack === stack) activeDeckVisualStack = null;
  });
}

function setDeckVisualCardFace(card, showBack) {
  if (!card) return;

  var dfcCards = card.querySelectorAll('.deck-visual-card-dfc');
  if (!dfcCards.length) return;

  if (card._cardTrayDfcFlipTimer) {
    window.clearTimeout(card._cardTrayDfcFlipTimer);
  }
  card.classList.add('is-dfc-flipping');
  card._cardTrayDfcFlipTimer = window.setTimeout(function() {
    card.classList.remove('is-dfc-flipping');
    card._cardTrayDfcFlipTimer = null;
  }, 850);

  dfcCards.forEach(function(dfcCard) {
    dfcCard.classList.toggle('active', showBack);
  });
  card.classList.toggle('is-dfc-back', showBack);

  var toggle = card.querySelector('.deck-visual-dfc-toggle');
  if (toggle) {
    toggle.setAttribute('aria-pressed', showBack ? 'true' : 'false');
    toggle.setAttribute('aria-label', showBack ? 'Show front face' : 'Flip card face');
  }
}

function eventIsInsideElement(event, element) {
  if (!event || !element || typeof element.getBoundingClientRect !== 'function') return false;

  var rect = element.getBoundingClientRect();
  return event.clientX >= rect.left &&
    event.clientX <= rect.right &&
    event.clientY >= rect.top &&
    event.clientY <= rect.bottom;
}

function initializeDeckVisualDfcToggle() {
  document.addEventListener('click', function(e) {
    var toggle = Array.from(document.querySelectorAll('.deck-visual-card[data-card-image-back] .deck-visual-dfc-toggle')).find(function(button) {
      return eventIsInsideElement(e, button);
    });
    if (!eventIsInsideElement(e, toggle)) return;

    var card = toggle.closest('.deck-visual-card[data-card-image-back]');
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();
    setDeckVisualCardFace(card, !card.classList.contains('is-dfc-back'));
  }, true);

  document.addEventListener('click', function(e) {
    var toggle = e.target && e.target.closest('.deck-visual-dfc-toggle');
    if (!toggle) return;

    e.preventDefault();
    e.stopPropagation();

    var card = toggle.closest('.deck-visual-card');
    if (!card) return;
    setDeckVisualCardFace(card, !card.classList.contains('is-dfc-back'));
  });
}

function initializeDeckVisualDesktopDfcCardLinks() {
  document.addEventListener('click', function(e) {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (e.target && e.target.closest('.deck-visual-dfc-toggle')) return;
    if (e.target && e.target.closest('.deck-visual-editable-controls, [data-deck-edit-action], .deck-preview-actions, [data-card-tray-card], .card-tray-image-menu')) return;

    var card = e.target && e.target.closest('.deck-visual-card[data-card-image-back]');
    if (!card || !card.dataset.cardUrl) return;

    window.location.href = card.dataset.cardUrl;
  });
}

function initializeDeckVisualStackCardLinks() {
  document.addEventListener('click', function(e) {
    if (!canUseDeckVisualStackHover()) return;
    if (e.defaultPrevented) return;
    if (e.target && e.target.closest('.deck-visual-dfc-toggle')) return;
    if (e.target && e.target.closest('.deck-visual-editable-controls, [data-deck-edit-action], .deck-preview-actions, [data-card-tray-card], .card-tray-image-menu')) return;

    var card = e.target && e.target.closest('.deck-visual-container-stacks .deck-visual-card[data-card-url], .deck-visual-container-copy_stacks .deck-visual-card[data-card-url]');
    if (!card || card.dataset.cardImageBack) return;

    window.location.href = card.dataset.cardUrl;
  });
}

window.MTGGoldfish = MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {
  splitDecklistsIntoTwoColumns();
  initializeDeckVisualStackHover();
  initializeDeckVisualDfcToggle();
  initializeDeckVisualDesktopDfcCardLinks();
  initializeDeckVisualStackCardLinks();

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.decklist-more')) return;
    e.target.style.display = 'none';
    var more = e.target.closest(".decklist-more-container");
    if (more) {
      var purchase = more.querySelector(".decklist-purchase-more");
      if (purchase) purchase.style.display = '';
    }
  });

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.deck-tools-btn-download-submit')) return;
    e.preventDefault();
    var form = e.target.closest('form');
    if (!form) return;
    var outputField = form.querySelector(".field-output");
    var typeField = form.querySelector(".field-type");
    if (outputField) outputField.value = e.target.dataset.output;
    if (typeField) typeField.value = e.target.dataset.type;
    form.submit();
  });

  document.querySelectorAll(".copy-paste-box").forEach(function(el) {
    el.style.height = el.scrollHeight + "px";
    el.addEventListener('click', function() { el.select(); });
  });

  document.querySelectorAll(".auto-select-text").forEach(function(el) {
    el.addEventListener('click', function() { el.select(); });
  });

  document.querySelectorAll(".my-decks-btn-add").forEach(function(el) {
    el.addEventListener('click', function(e) {
      var target = el.dataset.target;
      var textarea = document.getElementById(target);
      var card = document.querySelector('.add-card-' + target);
      var qty = document.querySelector('.add-qty-' + target);
      if (textarea && card && qty) {
        textarea.value = textarea.value + "\n" + qty.value + " " + card.value;
      }
    });
  });

  function showDecksTab(panelName) {
    var filterPanel = document.getElementById("search-filter-panel");
    if (filterPanel) filterPanel.value = panelName;

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const params = new URLSearchParams({ panel: panelName });
    const url = `/decks?${params.toString()}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': csrfToken
      },
      credentials: 'same-origin'
    })
    .then(response => {
      if (!response.ok) throw new Error("Turbo Stream request failed");
      return response.text();
    })
    .then(html => {
      Turbo.renderStreamMessage(html);
    })
    .catch(error => {
      console.error(error);
    });
  }

  document.addEventListener('shown.bs.tab', function(e) {
    var tabEl = e.target;
    var container = document.getElementById('mydecks-tabs');
    if (!container || !container.contains(tabEl)) return;
    if (!tabEl.matches('[data-bs-toggle="tab"]')) return;
    var hash = tabEl.getAttribute('href') || tabEl.dataset.bsTarget;
    if (hash !== "#tab-search") {
      showDecksTab(hash);
    }
    var relatedHash = e.relatedTarget && (e.relatedTarget.getAttribute('href') || e.relatedTarget.dataset.bsTarget);
    if (relatedHash) {
      var relatedPaneId = relatedHash.charAt(0) === '#' ? relatedHash.slice(1) : relatedHash;
      var relatedTab = document.getElementById(relatedPaneId);
      if (relatedTab) {
        if (hash === "#tab-search") {
          relatedTab.innerHTML = "<p class='empty'>Search Results have expired. Please search again.</p>";
        } else {
          relatedTab.innerHTML = "<p class='empty'>Loading ...</p>";
        }
      }
    }
  });

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest('.hidden-form-submit')) return;
    var submitEl = e.target.closest('.hidden-form-submit');
    var hiddenForm = submitEl.querySelector(".hidden-form");
    if (!hiddenForm) return;
    var f = document.createElement('form');
    f.target = '_blank';
    f.method = 'POST';
    f.style.display = 'none';
    f.action = hiddenForm.dataset.url;
    hiddenForm.querySelectorAll(".hidden-form-input").forEach(function(inp) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = inp.dataset.name;
      input.value = inp.dataset.value;
      f.appendChild(input);
    });
    document.body.appendChild(f);
    f.submit();
    document.body.removeChild(f);
  });

});

window.initializeDeckComponents = initializeDeckComponents;
window.initializeEditableDeckPreview = initializeEditableDeckPreview;
window.requestDeckPreview = requestDeckPreview;
window.syncEditableDeckPreviewBeforeFormAction = syncEditableDeckPreviewBeforeFormAction;
window.splitDecklistsIntoTwoColumns = splitDecklistsIntoTwoColumns;
window.initializeTypePreference = initializeTypePreference;
